import ArnOutdatedWarning from "./ArnOutdatedWarning.vue"
export default ArnOutdatedWarning
